export default __webpack_public_path__ + "static/media/P204 zu P203.98f4a536.mp3";